// @flow strict
/* eslint-disable css-modules/no-undef-class */
import * as React from 'react';
import classnames from '@ta/common.classnames';
import Icon, { type IconName } from '@ta/core-ui.icon';
import styles from './TitleBar.css';

/** These are styleguide-defined header types https://docs.dev.tripadvisor.com/display/STYLE/Modals */
export type TitleDisplayType = 'CENTERED_WHITE' | 'LEFT_ALIGN_GRAY' | 'LEFT_ALIGN_GREEN';

type Props = {|
  /** The children that make up the title content */
  children: React.Node,

  /**
   * Name of icon. See https://styleguide.nw.dev.tripadvisor.com/StyleGuide/icons. Currently only designed for
   * LEFT_ALIGN_GRAY display type
   */
  iconName?: IconName,

  /**
   * The styleguide-defined header type. Can be 'CENTERED_WHITE' or 'LEFT_ALIGN_GRAY'.
   * See https://docs.dev.tripadvisor.com/display/STYLE/Modals for more info.
   */
  displayType?: TitleDisplayType,
|};

const TitleBar = ({ displayType = 'CENTERED_WHITE', iconName, children }: Props) => (
  <div
    className={classnames(
      {
        [styles.leftAligned]:
          displayType === 'LEFT_ALIGN_GREEN' || displayType === 'LEFT_ALIGN_GRAY',
        [styles.green]: displayType === 'LEFT_ALIGN_GREEN',
        [styles.gray]: displayType === 'LEFT_ALIGN_GRAY',
        [styles.centeredWhite]: displayType === 'CENTERED_WHITE',
        [styles.hasIcon]: iconName && displayType === 'LEFT_ALIGN_GRAY',
      },
      styles.titleContainer,
    )}
  >
    {iconName && (
      <div className={styles.iconContainer}>
        <Icon name={iconName} />
      </div>
    )}
    {children}
  </div>
);

export default TitleBar;
